import './testimonial-carousel.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSTestimonialCarousel } from './testimonial-carousel';
import { GSTestimonialCarouselItem } from './testimonial-carousel-item';

components.register({
	selector: '.gs-TestimonialCarousel',
	controller: GSTestimonialCarousel
});

components.register({
	selector: '.gs-TestimonialCarousel-item',
	controller: GSTestimonialCarouselItem
});
